import { cbSemanticCssVars, colors } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import styled from 'styled-components';

import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { typographyCss } from 'common/typography';
import { DiscountedItem } from 'modules/campaigns/hooks/useDiscountedItems';

type SelectedDiscountItemProps = {
  item: DiscountedItem;
};

const ItemContainer = styled.li`
  display: flex;
  align-items: center;
  border-radius: 8px;
  /* TODO when new colors available: bg-surface-secondary */
  background: ${cssThemedValue({ light: colors.pepper4, dark: colors.salt8 })};
  padding-block: 4px;
  padding-inline-start: 4px;
  padding-inline-end: 8px;
  gap: 4px;
  overflow: hidden;
`;

const ImageContainer = styled.span`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: ${cbSemanticCssVars.surfaceMain};
  overflow: hidden;
`;

const ItemImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ItemName = styled.div`
  ${typographyCss.Small}
  font-weight: 500;
  margin-inline-end: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ItemPrice = styled.div`
  ${typographyCss.Body3}
  font-weight: 500;
  color: ${colors.wolt100};
  margin-inline-start: auto;
`;

export const SelectedDiscountItem = ({ item }: SelectedDiscountItemProps) => {
  return (
    <ItemContainer>
      <ImageContainer>{item.image ? <ItemImage src={item.image} alt="" aria-hidden="true" /> : null}</ImageContainer>
      <ItemName>{item.name}</ItemName>
      <ItemPrice>
        <MonetaryAmount amount={parseFloat(item.baseprice.amount)} currency={item.baseprice.currency} />
      </ItemPrice>
    </ItemContainer>
  );
};
